import { Observable } from 'rxjs/Observable';

export class DashboardUtils {
  static totalAsStringClampedTo99(totalObs: Observable<number>): Observable<string> {
    return totalObs.map(total => total >= 99 ? '99+' : String(total));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/dashboard-util.ts